module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.4452/img/callout-wave.svg"